import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteTypes } from '~/routes/constants';
import { Grid, Label } from 'semantic-ui-react';
import Layout from '~/components/Layout';
import notify from '~/components/Notify';
import NewsletterService from '~/api/services/newsletter';
import { useParams } from 'react-router-dom';
import { StyledSegment } from './style';
import dayjs from 'dayjs';
import { b64toBlob, handleErrors } from '~/utils/helpers';
import Dialog from '~/components/Dialog';
import { IndicatorsContext } from '~/components/InnerContent';

const ShowNewsletterDairy: React.FC = () => {
  const { t } = useTranslation();
  const { id } = useParams()
  const [isBusy, setIsBusy] = useState(false);
  const [showData, setShowData] = useState(null)
  const [fileSource, setFileSource] = useState(null)
  const { indicators, setIndicators } = useContext(IndicatorsContext)

  useEffect(() => {
    if (id) {
      fetchShowData();
    }
  }, [t]);

  async function fetchShowData() {
    setIsBusy(true)
    try {
      const showResponse = await NewsletterService.getPreviewNewsletter(id);
      const tempArray = [...indicators]
      const index = tempArray.findIndex(indicator => indicator.key === 'newsletter-indicator')
      if(showResponse.data?.openedInApp === 0 && tempArray[index].value > 0) {
        tempArray[index].value = tempArray[index].value - 1
        setIndicators(tempArray)
      }
      setShowData(showResponse.data);
    } catch (error) {
      if (error?.response?.data) {
        notify(error?.response?.data?.message, 'error');
      } else {
        notify(t('General error'), 'error');
      }
    }
    setIsBusy(false)
  }

  const handleDownloadPdf = async (fileName) => {
    setIsBusy(true);
    try {
      const response = await NewsletterService.getFileNewsletter(id, { fileName: fileName });
      const type = response.data.split(';')[0].split('data:')[1]
      const blob = b64toBlob(response.data, type);
      const blobUrl = URL.createObjectURL(blob);
      setFileSource(blobUrl);
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false);
  };

  function renderAttachmentLabel(attachment) {
    return <Label
      basic
      onClick={() => handleDownloadPdf(attachment?.attachment)}
      color='blue'
      as='a'
      content={attachment?.originalFilename}
      icon='file'
    />
  }

  function renderPreview() {
    return <>
      <StyledSegment>
        <Grid columns={2} stackable>
          <Grid.Row>
            <Grid.Column>
              <strong>{t('Received on')}</strong>
              <div className='value'>{dayjs(showData?.receivedAt).format('DD.MM.YYYY HH:mm')}</div>
            </Grid.Column>
            <Grid.Column>
              <strong>{t('Attachments')}</strong>
              <div className=''>
                {showData?.attachments?.map(attachment => {
                  return renderAttachmentLabel(attachment)
                })}
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </StyledSegment>
      <StyledSegment>
        <Grid columns={1}>
          <Grid.Row columns={1}>
            <Grid.Column>
              <strong>{t('Subject')}</strong>
              <div className='value'>{showData?.subject}</div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={1}>
            <Grid.Column>
              <strong>{t('Content')}</strong>
              <div dangerouslySetInnerHTML={{ __html: showData?.content }} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </StyledSegment>
    </>
  }

  const renderModalPreviewFile = () => {
    return <Dialog
      open={Boolean(fileSource)}
      handleClose={() => setFileSource(null)}
      textContent={<iframe width='100%' height='100%' src={fileSource}></iframe>}
      textHeader={t('Preview')}
      textClose={t('Close')}
      type={'preview'}
    />
  };

  return <Layout
    isBusy={isBusy}
    segmented
    title={t('Newsletter preview')}
    close={RouteTypes.NEWSLETTER}
  >
    {renderPreview()}
    {renderModalPreviewFile()}
  </Layout>;
};
export default ShowNewsletterDairy;
